export const licensing = {
    restrict: [],
    visible: false,
};